import {connect} from "react-redux"
import {createSelector} from "reselect"
import {State} from "ducks"
import {deleteRecentQueries} from "../../../../ducks/recents/index"

const textSelector = createSelector(
    (state: State) => state.text,
    text => {
        const {
            recentSearches: {enriched, clearAllButton},
        } = text
        return {...enriched, clearAllButton}
    },
)
export const mapStateToProps = (state: State) => {
    const {
        recents: {queryIds},
        template,
    } = state

    const showClearAll = queryIds && queryIds.length > 0

    return {
        text: textSelector(state),
        showClearAll,
        templating: template,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    clear: () => {
        dispatch(deleteRecentQueries())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
